import InputTag from './src/input-tag2.mjs';
export { inputTagEmits, inputTagProps } from './src/input-tag.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInputTag = withInstall(InputTag);

export { ElInputTag, ElInputTag as default };
//# sourceMappingURL=index.mjs.map
